module.exports = new __parcel__URL__("nordstrom-icon.a6f5731d.jpg").toString();